export default __webpack_public_path__ + "static/media/customerService.82910a73.jpg";